import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `movimientoVerraco/comprobarUbicacionLibre`, method: 'POST', body: values, token: token})
}